(function () {
  if (window.wishlistPopupInitialized) return;
  window.wishlistPopupInitialized = true;

  function popupEl() {
    return document.getElementById('WishlistPopup');
  }

  function open(popup) {
    popup.hidden = false;
    document.body.classList.add('overflow-hidden');
    var dialog = popup.querySelector('.wishlist-popup__dialog');
    if (dialog) dialog.focus();
  }

  function close(popup) {
    popup.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function resizeImage(url, size) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
  }

  function renderProduct(container, product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var formatMoney = window.Wishlist && window.Wishlist.formatMoney;
    var moneyFormat = container.getAttribute('data-money-format') || '{{amount}}';
    var price = formatMoney ? formatMoney(product.price, moneyFormat) : '';

    container.innerHTML =
      (image
        ? '<div class="wishlist-popup__product-media"><img src="' + escapeHtml(resizeImage(image, 140)) + '" alt="' + escapeHtml(product.title) + '"></div>'
        : '') +
      '<div class="wishlist-popup__product-body">' +
        '<p class="wishlist-popup__product-title">' + escapeHtml(product.title) + '</p>' +
        (price ? '<p class="wishlist-popup__product-price">' + escapeHtml(price) + '</p>' : '') +
      '</div>';
  }

  async function showForHandle(popup, handle) {
    var container = document.getElementById('wishlist-popup-product');
    if (container) container.innerHTML = '';

    try {
      var response = await fetch('/products/' + handle + '.js');
      if (response.ok && container) {
        var product = await response.json();
        renderProduct(container, product);
      }
    } catch (error) {
      // Popup still opens without the product preview.
    }

    open(popup);
  }

  document.addEventListener('wishlist:updated', function (event) {
    var detail = event.detail || {};
    if (!detail.added || !detail.handle) return;
    var popup = popupEl();
    if (popup) showForHandle(popup, detail.handle);
  });

  document.addEventListener('click', function (event) {
    var popup = event.target.closest('[data-wishlist-popup]');
    if (!popup) return;
    if (event.target.closest('[data-wishlist-popup-close]')) close(popup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var popup = popupEl();
    if (popup && !popup.hidden) close(popup);
  });
})();
